import { useState } from "react";
import NameCodeFile from "../CodeFiles/NameCodeFile";
import Sidebar from "../Sidebar/Sidebar";
import "./About.scss";
import Description from "./Description";
import HighSchool from "./HighSchool";
import FullStackDevCalx from "./FullStackDevCalx";
import FullStackDevKian from "./FullStackDevKian";
import FullStackDevSotunec from "./FullStackDevSotunec";
export default function About() {
  const [file, setFile] = useState<any>({
    id: "personal-info-file",
    name: "personal-info",
  });

  // test push action
  return (
    <div className="about-layout">
      <div className="about-layout__about-me">_about-me</div>
      <div className="about-layout__sidebar">
        <Sidebar
          onOpenFile={(file: any) => {
            setFile(file);
          }}
        />
      </div>
      <div className="about-layout__code">
        <div className="about-layout__code-container">
          <div className="about-layout__body">
            <div className="about-layout__body__name-file">
              {`// ${file.name}`}
            </div>
            <NameCodeFile file={file} />
            <div className="about-layout__body__code">
              {file.id === "personal-info-file" && <Description />}
              {file.id === "high-school" && <HighSchool />}
              {file.id === "sotunec" && <FullStackDevSotunec />}
              {file.id === "calx" && <FullStackDevCalx />}
              {file.id === "kian" && <FullStackDevKian />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
